import {Typography} from '@mui/material';
import {
	AlertInfo,
	BeneficiaryCard,
	MainFooter,
	MainHeader,
	PageWrapperLayout,
	StyledGrid,
} from 'presentation/components';
import {useAccountInformation, useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import React, {SyntheticEvent, useState} from 'react';
import {HomeEnum} from 'presentation/constants';
import {useNavigate} from 'react-router-dom';
import {useContractStatus} from 'presentation/hooks';
import {Accordion} from './components/Accordion';
import {StyledBox, StyledFooterContainer} from './styles';

const {
	title,
	canceledContractInformation,
	canceledContractInformationResponsibleWithoutBenefits,
	alertDescription,
} = translations['pt-br'].privateFlow.canceledContractFindOutMore;

export function CanceledContractFindOutMore() {
	const [expanded, setExpanded] = useState<string | false>('panel0');

	const {isMobile} = useMediaQueries();
	const navigate = useNavigate();
	const {formattedPeriod} = useContractStatus();
	const {isResponsibleWithoutBenefits} = useAccountInformation();

	const listInfos = isResponsibleWithoutBenefits
		? canceledContractInformationResponsibleWithoutBenefits
		: canceledContractInformation;

	const handleChangeAccordion =
		(panel: string) => (_event: SyntheticEvent, isExpanded: boolean) => {
			setExpanded(isExpanded ? panel : false);
		};

	const handleBack = () => {
		navigate(HomeEnum.HOME_PAGE);
	};

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				variant="subRoute"
				title={title}
				handleBack={handleBack}
				handleClose={handleBack}
			/>
			<AlertInfo.Root sx={{borderRadius: 0}} severity="warning">
				<AlertInfo.Description>
					<Typography>
						{alertDescription} <b>{formattedPeriod}.</b>
					</Typography>
				</AlertInfo.Description>
			</AlertInfo.Root>

			<StyledGrid.Root px={isMobile ? 2 : 4} spacing={3} mt={1}>
				<StyledGrid.Item sm={12} md={8} lg={8} mt={isMobile ? 1 : 0}>
					<StyledBox>
						{Object.entries(listInfos).map(([key, section]) => (
							<Accordion
								key={key}
								title={section.subtitle}
								items={section.items}
								expanded={expanded === `panel${key}`}
								onChange={handleChangeAccordion(`panel${key}`)}
							/>
						))}
					</StyledBox>
				</StyledGrid.Item>

				<StyledGrid.Item sm={12} md={4} lg={4}>
					<BeneficiaryCard shouldShowAnsPlanRegister={false} />
				</StyledGrid.Item>
			</StyledGrid.Root>

			<StyledFooterContainer $mb={72}>
				<MainFooter />
			</StyledFooterContainer>
		</PageWrapperLayout>
	);
}
